import { render, staticRenderFns } from "./DashboardMain.vue?vue&type=template&id=472cf5ba&scoped=true"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"
import style0 from "./DashboardMain.vue?vue&type=style&index=0&id=472cf5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cf5ba",
  null
  
)

export default component.exports